export function loadUmamiScript(clientKey, clientConfig, env, umamiUrl) {
  if (!umamiUrl) return; // Skip if no analytics url
  const clientSettings = clientConfig[clientKey]?.umamiSettings;

  if (!clientSettings?.canUseUmami) return; // Skip loading if Umami tracking isn't enabled
  const trackingId = clientSettings[env]?.trackingId;

  if (!clientSettings[env]?.enabled || !trackingId) return;

  const existingScript = document.querySelector(`script[data-website-id="${trackingId}"]`);
  if (existingScript) {
    console.info("umami already loaded" + existingScript);
    return; // Prevent duplicate scripts
  }

  const script = document.createElement("script");
  script.src = umamiUrl;
  script.async = true;
  script.defer = true;
  script.dataset.websiteId = trackingId;
  script.setAttribute("data-before-send", "beforeUmamiSendHandler"); // Add the attribute

  const comment = document.createComment("Umami");
  document.head.appendChild(comment);
  document.head.appendChild(script);
  console.info("umami loaded");
}

export function getClientFromLocalUrl() {
  const url = window.location.href; // Get full URL
  const hashIndex = url.indexOf("?");

  if (hashIndex === -1) return null; // No query parameters

  const queryString = url.substring(hashIndex); // Extract query string
  const params = new URLSearchParams(queryString);

  return params.get("client"); // Get the client parameter
}
